import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../styles/cursos.css";
import heroCursos from "../assets/courses/banner.png";
import api from "../services/api";

const ITEMS_PER_PAGE = 12;

const Cursos = () => {
  const [cursos, setCursos] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchCursos = async () => {
      try {
        const res = await api.get("/cursos/");
        // si usas paginación DRF:
        setCursos(res.data.results ?? res.data);
      } catch (err) {
        console.error("Error cargando cursos", err);
      }
    };

    fetchCursos();
  }, []);
  const formatFecha = (isoDate) =>
    new Date(isoDate).toLocaleDateString("es-BO", {
      year: "numeric",
      month: "long",
    });
  

  const totalPages = Math.ceil(cursos.length / ITEMS_PER_PAGE);
  const start = (page - 1) * ITEMS_PER_PAGE;
  const paginated = cursos.slice(start, start + ITEMS_PER_PAGE);

  return (
    <div className="cursos-page">
      {/* HERO */}
      <section
        className="hero-cursos"
        style={{ backgroundImage: `url(${heroCursos})` }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1>Formación Especializada en Ingeniería Sanitaria y Ambiental</h1>
            <p>
              ABIS La Paz impulsa la capacitación continua de sus asociados
              mediante cursos, talleres y programas técnicos de alto nivel.
            </p>
            <p>
              Promovemos el perfeccionamiento profesional y la actualización
              científica para fortalecer las competencias del sector y responder
              a los desafíos del saneamiento básico y la gestión ambiental.
            </p>
          </div>
        </div>
      </section>

      {/* GRID DE CURSOS */}
      <section className="cursos-grid">
        {paginated.map((curso) => (
          <div
            className="curso-card"
            key={curso.id}
            onClick={() => navigate(`/cursos/${curso.id}`)}
            style={{ cursor: "pointer" }}
          >
            <div className="curso-img">
              <img src={curso.portada} alt={curso.titulo} loading="lazy" />
            </div>
            <div className="curso-info">
              <span className="curso-fecha">{formatFecha(curso.fpublicacion)}</span>
              <h3>{curso.titulo}</h3>
              <p className="curso-cat">{curso.categoria}</p>
              <p className="curso-desc">{curso.descripcion}</p>
            </div>
          </div>
        ))}
      </section>
      {/* PAGINACIÓN */}
          {totalPages > 1 && (
            <div className="pagination">
              <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                Anterior
              </button>
  
              <span>
                Página {page} de {totalPages}
              </span>
  
              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Siguiente
              </button>
            </div>
          )}
    </div>
  );
};

export default Cursos;
